import { jsx as _jsx } from "react/jsx-runtime";
import { DBDef_Reference } from '@app/hcs-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_Reference, resolveReferenceDisplay } from '../../_entity.js';
import { Manager_WorkHub_Reference } from '../../ui/_managers/Manager_WorkHub_Reference/Manager_WorkHub_Reference.js';
import { Preview_Reference } from '../../ui/_previews/index.js';
import { displayEntityDependencies } from '@app/styles/frontend/ui/consts';
import { Renderer_SearchResult, SearchResult_BaseRightClickActions } from '@app/styles/frontend/ui/components/Renderer_SearchResult/Renderer_SearchResult';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_Reference,
    dbDef: DBDef_Reference,
    tag: ['Rf', 'Reference'],
    modulesToAwait: [ModuleFE_Reference],
    ManagerComponent: Manager_WorkHub_Reference,
    customLabelResolver: (entity) => resolveReferenceDisplay(entity),
    extraMenuSections: (_entity, tab) => [
        {
            actions: [
                {
                    label: 'Check Usage',
                    action: () => displayEntityDependencies(DBDef_Reference.dbKey, tab.renderArgs.itemId),
                },
            ],
        },
    ],
    resultRenderer: (pointer, style) => {
        const ref = ModuleFE_Reference.cache.unique(pointer.id);
        return _jsx(Renderer_SearchResult, { entity: ref, style: style, entityLabel: 'Reference', itemLabel: ref ? resolveReferenceDisplay(ref) : 'N/A', subtitle: ref?.type, onClickAction: () => UtilObject_Reference.openEditor(pointer.id), rightClickActions: [
                ...SearchResult_BaseRightClickActions(ref),
                { label: 'Check Usage', action: () => displayEntityDependencies(pointer.dbKey, pointer.id) },
                { label: 'Show Preview', action: () => Preview_Reference.show(pointer.id) },
            ] });
    }
});
export const WorkHubItem_Reference = WorkHubItem;
export const UtilObject_Reference = UtilObject;
export const SearchItem_Reference = SearchItem;
//# sourceMappingURL=reference.js.map